/**
 * Riskmatik Kurumsal Kimlik SSoT
 * ================================
 * Tüm yasal sayfalar (KVKK, Gizlilik, Kullanım Koşulları, Çerez, İletişim,
 * Hakkımızda) + Footer + Schema.org Organization bu dosyadan okur.
 *
 * Kaynak: Vergi Levhası (11.05.2026 işe başlama, sanal ofis kurulumu)
 * Adres tipi: Sanal Ofis — public yayım uygun.
 *
 * Görünürlük politikası (katmanlı):
 *   - Katman A (yasal zorunluluk): mukellefAdi/Acik açık. SADECE KVKK Md. 10
 *     veri sorumlusu, 6502 SK Md. 4 sağlayıcı kimliği gibi mevzuat gerektirdiği
 *     içerik bloklarında kullanılır.
 *   - Katman B (kurumsal yüz): Footer, Hakkımızda, İletişim, Schema.org
 *     Organization. Marka + adres + VKN ön planda; kişi adı KULLANILMAZ.
 *   - Katman C (marketing/SEO): Sadece marka adı.
 *
 * TC Kimlik No bu dosyada YOK — bilinçli (public bundle'a sızabilir, ayrıca
 * KVKK Md. 10/2-a için VKN yeterli). TC sadece DB/admin'de tutulur.
 */

export const KURUMSAL_KIMLIK = {
  // === KURUMSAL YÜZ (her katmanda) ===
  marka: 'Riskmatik',
  markaUzun: 'Riskmatik — İş Sağlığı ve Güvenliği Yazılımı',
  url: 'https://www.riskmatik.com',
  logo: 'https://www.riskmatik.com/images/riskmatik-logo.svg',
  // 🔴 Schema.org image/screenshot RASTER olmalı — Google yapılandırılmış-veri image'inde SVG KABUL ETMEZ
  // (Product/SoftwareApplication/merchant rich result → JPEG/PNG/WebP). Bu yüzden `logo`(SVG) DEĞİL bu kullanılır.
  gorselPng: 'https://www.riskmatik.com/og-image-v4.png',
  kurulusTarihi: '2026-05-11',                // ISO 8601 — vergi levhası işe başlama
  faaliyetAlani: 'Bilgisayar Programlama / SaaS',
  merkezSehir: 'Antalya',                      // Kısa kurumsal etiket

  // === YASAL MÜKELLEF (SADECE Katman A — yasal sayfalarda) ===
  mukellefAdi: 'Ali Zorlu',
  mukellefAdiAcik: 'Ali Zorlu (Riskmatik markası altında)',
  isletmeTuru: 'Şahıs Firması',
  vkn: '9990375659',
  vergiDairesi: 'Düden',
  nace: '62.01.00',
  naceAdi: 'Bilgisayar Programlama Faaliyetleri',

  // === ADRES (her katmanda — Schema.org PostalAddress uyumlu) ===
  adres: {
    streetAddress: 'Konuksever Mah. Gazi Blv. No: 220',
    addressLocality: 'Muratpaşa',     // ilçe
    addressRegion: 'Antalya',          // il
    postalCode: '07010',
    addressCountry: 'TR',
  },

  // === İLETİŞİM (her katmanda) ===
  destekEmail: 'destek@riskmatik.com',
  kep: 'ali.zorlu.7@hs01.kep.tr' as string | null, // PTT KEP bireysel, 2026-05-14 aktif
  telefon: '+90 535 256 21 15' as string | null, // GSM — sanal ofis sabit hat alınca güncelle
  telefonRaw: '+905352562115', // tel: href için boşluksuz format
  calismaSaatleri: 'Pazartesi–Cuma · 09:00–18:00 (TSİ)',
  calismaSaatleriIso: 'Mo-Fr 09:00-18:00',  // Schema.org openingHours

  // === İYZİCO ÖDEME (Sanal POS başvurusu 2026-05-14) ===
  odemeSaglayici: 'İyzi Ödeme ve Elektronik Para Hizmetleri A.Ş. (iyzico)',
  odemeSaglayiciAciklama: 'TCMB lisanslı, 3D Secure ile güvenli ödeme',

  /**
   * ETBİS sicil bilgileri — T.C. Ticaret Bakanlığı Elektronik Ticaret Bilgi
   * Sistemi kaydı. 6563 sayılı Elektronik Ticaretin Düzenlenmesi Hakkında Kanun ve Elektronik Ticarette Hizmet Sağlayıcı ve Aracı Hizmet Sağlayıcılar Hakkında Yönetmelik + Yönetmelik
   * Md. 5 gereği sicil bilgisi sitede görünür olmak zorundadır.
   *
   * Görünür yerler (`<EtbisBadge>` component'i ile):
   *   - Footer (variant="compact")
   *   - İletişim sayfası (variant="card")
   *   - Hakkımızda sayfası (variant="card")
   *   - KVKK Aydınlatma sayfası (variant="full")
   *
   * Schema.org Organization `identifier` array'inde de yayınlanır
   * (Google rich snippet doğrulama mührü).
   */
  etbis: {
    sicilTarihi: '2026-05-15' as const,
    siteId: '3df3ee9e-0266-484f-b5a1-f1370cce4570' as const,
    dogrulamaUrl: 'https://etbis.ticaret.gov.tr/tr/SiteSorgulamaSonuc?siteId=3df3ee9e-0266-484f-b5a1-f1370cce4570',
    qrPath: '/images/etbis/riskmatik-etbis-qr.png',
    qrPathSvg: '/images/etbis/riskmatik-etbis-qr.svg',
    /** Yasal dayanak — KVKK/yasal sayfalarda gösterilecek metin */
    mevzuatRef: '6563 sayılı Elektronik Ticaretin Düzenlenmesi Hakkında Kanun ve Elektronik Ticarette Hizmet Sağlayıcı ve Aracı Hizmet Sağlayıcılar Hakkında Yönetmelik',
  },

  /**
   * Sosyal medya & dış otorite kayıtları — Schema.org Organization.sameAs için
   * AI Knowledge Graph + arama motorları entity disambiguation sinyali.
   *
   * Eklenirken:
   *   - Hesap KURUMSAL adına olmalı (kişi adı YOK — Katman B kuralı)
   *   - Resmi onaylı/doğrulanmış URL (Verified badge varsa öncelikli)
   *   - HTTPS zorunlu, trailing slash kullanım tutarlı
   */
  sosyalMedya: {
    /** LinkedIn Company Page — 2026-05-28 kuruldu, 20 uzmanlık etiketi, public yayında */
    linkedin: 'https://www.linkedin.com/company/riskmatik/' as string | null,
    /**
     * Wikidata entity — Q139961515 2026-05-28 oluşturuldu AMA moderatörler 2026-06-27
     * "Spam / advertising" gerekçesiyle SİLDİ (self-add + bağımsız kaynak yok). QID artık 404.
     * → null: ölü sameAs sinyali vermeyelim. Yeniden ekleme = bağımsız haber-kaynağı çıkınca (backlink işiyle).
     */
    wikidata: null as string | null,
    /** Twitter/X hesabı — açılınca eklenir */
    twitter: null as string | null,
    /** YouTube kanalı — açılınca eklenir */
    youtube: null as string | null,
    /** Instagram hesabı — açılınca eklenir */
    instagram: null as string | null,
  },
} as const;

export type KurumsalKimlik = typeof KURUMSAL_KIMLIK;

/**
 * Adres tek satır — kart/inline gösterim için.
 * "Konuksever Mah. Gazi Blv. No: 220, Muratpaşa/Antalya 07010"
 */
export function formatAdresTekSatir(): string {
  const a = KURUMSAL_KIMLIK.adres;
  return `${a.streetAddress}, ${a.addressLocality}/${a.addressRegion} ${a.postalCode}`;
}

/**
 * Adres çok satır — kart layout için (sokak / ilçe-il-pk / ülke).
 */
export function formatAdresCokSatir(): readonly string[] {
  const a = KURUMSAL_KIMLIK.adres;
  return [
    a.streetAddress,
    `${a.addressLocality}/${a.addressRegion} ${a.postalCode}`,
    'Türkiye',
  ];
}

/**
 * Footer / kurumsal mini blok için tek satır kimlik.
 * Kişi adı YOK — sadece marka + şehir + VKN.
 * "Riskmatik · Antalya · VKN: 9990375659"
 */
export function formatKurumsalKisa(): string {
  return `${KURUMSAL_KIMLIK.marka} · ${KURUMSAL_KIMLIK.merkezSehir} · VKN: ${KURUMSAL_KIMLIK.vkn}`;
}
